import React from 'react';
import { t } from '@lingui/macro';

import OverflowTextModal from '@rover/components/src/OverflowTextModal/OverflowTextModal';
import { Box } from '@rover/kibble/core';

import { SitterProfileVersionOptions } from '../../constants';
import { sendSectionInteractionEvent } from '../../utils/sendSectionInteractionEvent';

type Props = {
  environment: string | undefined;
};

const RevampSafetyTrustSection = ({ environment }: Props): JSX.Element | null => {
  if (!environment) return null;

  return (
    <Box width="100%" data-testid="revamp-safety-trust" py="6x">
      <OverflowTextModal
        title={t`Safety, trust & environment`}
        text={environment}
        onReadMore={() => {
          sendSectionInteractionEvent('environment', {
            interactionType: 'expand',
            pageVariant: SitterProfileVersionOptions.REVAMP,
          });
        }}
      />
    </Box>
  );
};

export default RevampSafetyTrustSection;
